import { Buffer } from 'buffer';
import ipRangeCheck from 'ip-range-check';
import ipParser from '../ip';
import type { SignallingLog, SignallingLogBase, SignallingLogDoc } from './types';

export * from './types';

export function fromApi(doc: SignallingLogDoc): SignallingLog {
  return {
    ...parse(doc),
    logType: 'signalling',
  };
}

function parse(log: SignallingLogDoc): SignallingLogBase {
  const parsed = ipParser(Buffer.from(log.packet, 'hex'));
  const isFromOnomondo = parsed.sourceIp
    ? ipRangeCheck(parsed.sourceIp, ['185.228.68.0/22', '147.78.72.0/22', '212.9.6.127', '185.3.54.15'])
    : false;

  return {
    info: log.info,
    simId: log.sim_id,
    packet: log.packet,
    protocol: log.protocol,
    timestamp: log.timestamp,
    isFromOnomondo,
  };
}
